// eslint-disable-next-line import/named
import { runExport } from 'oneflow-client/positions';

import { getPositionFromSessionSelector } from 'reducers/session';

import { ExportUsersModal } from 'components/export-button/modals';
import { useSelector } from 'react-redux';

export const ExportUsers = () => {
  const email = useSelector(getPositionFromSessionSelector)?.email;

  const onExport = (onSuccess: () => void) => {
    runExport().then(onSuccess);
  };

  return (
    <ExportUsersModal
      onExport={onExport}
      email={email}
    />
  );
};
